import { api } from '../index';

export const getCollections = () => api.get('/partnership');

export const save = data => api.post('/partnership/save', data);
